import { env } from "./Env";

export const uploadToS3 = async (image: string, uploadURL: string) => {
  const headers = { Host: env.s3Host, 'Cache-Control': 'no-cache' };
  const response = await (await fetch(image)).blob();
  await fetch(uploadURL, { method: 'PUT', body: response, headers });
};
